'use client';

import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect, useRef } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import type { reducer } from '~/context/flp/Reducers';

type OwnProps = {
  aggregates: ReturnType<typeof reducer.aggregates>;
  financeTerms: ReturnType<typeof reducer.financeterms>;
  tradeIn: ReturnType<typeof reducer.tradein>;
};

export default function TermsUpdatedAnalytics({
  aggregates,
  financeTerms,
  tradeIn
}: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);
  const lastSentRef = useRef('');
  const termsKey = JSON.stringify({ aggregates, financeTerms, tradeIn });

  // Server re-renders hand us new object identities for identical data, so dedupe on content.
  useEffect(() => {
    if (lastSentRef.current === termsKey) {
      return;
    }

    lastSentRef.current = termsKey;

    const termsPayload = { aggregates, financeTerms, tradeIn };

    datadogRum.addAction(DATADOG_EVENTS.API.TERMS_UPDATED, termsPayload);
    trackEvent(ANALYTICS_EVENTS.PREQUALIFIED.TERMS_UPDATED, termsPayload);
  }, [aggregates, financeTerms, termsKey, tradeIn, trackEvent]);

  return null;
}
